import { useContext } from 'react';
import { VendorLockContext } from '../context/vendor-lock.context';

export const useVendorLock = () => {
  const vendor = useContext(VendorLockContext);

  return vendor;
};
